/* tslint:disable */
/* eslint-disable */
/**
 * ReD Admin API Spec
 * ReD中途企業向けサイト用API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: info@redesigner.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * プラン情報
 * @export
 * @interface GetAccount200ResponsePlan
 */
export interface GetAccount200ResponsePlan {
    /**
     * プラン名
     * @type {string}
     * @memberof GetAccount200ResponsePlan
     */
    title?: string;
    /**
     * バージョン 現在1,2
     * @type {number}
     * @memberof GetAccount200ResponsePlan
     */
    version?: number;
    /**
     * 求人編集可能フラグ
     * @type {boolean}
     * @memberof GetAccount200ResponsePlan
     */
    isEnableJobEdit?: boolean;
    /**
     * 求職者閲覧可能フラグ
     * @type {boolean}
     * @memberof GetAccount200ResponsePlan
     */
    isEnableUserRead?: boolean;
    /**
     * 求職者へのメッセージ・スカウト可能フラグ
     * @type {boolean}
     * @memberof GetAccount200ResponsePlan
     */
    isEnableScout?: boolean;
    /**
     * 検索条件対象通知フラグ
     * @type {boolean}
     * @memberof GetAccount200ResponsePlan
     */
    isNotifySearchConditionMatch?: boolean;
    /**
     * プラン開始日(年月日)
     * @type {string}
     * @memberof GetAccount200ResponsePlan
     */
    planStartDate?: string;
    /**
     * プラン終了日(年月日)
     * @type {string}
     * @memberof GetAccount200ResponsePlan
     */
    planEndDate?: string;
    /**
     * 基本プランバージョン
     * @type {number}
     * @memberof GetAccount200ResponsePlan
     */
    basisVersion?: number;
    /**
     * プレミア有効フラグ true:有効 false:無効
     * @type {boolean}
     * @memberof GetAccount200ResponsePlan
     */
    isPremium: boolean;
}

/**
 * Check if a given object implements the GetAccount200ResponsePlan interface.
 */
export function instanceOfGetAccount200ResponsePlan(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "isPremium" in value;

    return isInstance;
}

export function GetAccount200ResponsePlanFromJSON(json: any): GetAccount200ResponsePlan {
    return GetAccount200ResponsePlanFromJSONTyped(json, false);
}

export function GetAccount200ResponsePlanFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetAccount200ResponsePlan {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'title': !exists(json, 'title') ? undefined : json['title'],
        'version': !exists(json, 'version') ? undefined : json['version'],
        'isEnableJobEdit': !exists(json, 'is_enable_job_edit') ? undefined : json['is_enable_job_edit'],
        'isEnableUserRead': !exists(json, 'is_enable_user_read') ? undefined : json['is_enable_user_read'],
        'isEnableScout': !exists(json, 'is_enable_scout') ? undefined : json['is_enable_scout'],
        'isNotifySearchConditionMatch': !exists(json, 'is_notify_search_condition_match') ? undefined : json['is_notify_search_condition_match'],
        'planStartDate': !exists(json, 'plan_start_date') ? undefined : json['plan_start_date'],
        'planEndDate': !exists(json, 'plan_end_date') ? undefined : json['plan_end_date'],
        'basisVersion': !exists(json, 'basis_version') ? undefined : json['basis_version'],
        'isPremium': json['is_premium'],
    };
}

export function GetAccount200ResponsePlanToJSON(value?: GetAccount200ResponsePlan | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'title': value.title,
        'version': value.version,
        'is_enable_job_edit': value.isEnableJobEdit,
        'is_enable_user_read': value.isEnableUserRead,
        'is_enable_scout': value.isEnableScout,
        'is_notify_search_condition_match': value.isNotifySearchConditionMatch,
        'plan_start_date': value.planStartDate,
        'plan_end_date': value.planEndDate,
        'basis_version': value.basisVersion,
        'is_premium': value.isPremium,
    };
}

